/* eslint-disable @typescript-eslint/no-explicit-any */
import { hall } from '@/hall'
import { ModuleBase } from './ModuleBase'
import { base } from '@/base/base'
import { serverErrorMsg } from '@/defines/ServerError'
import { WebDefine } from '@/defines/WebDefine'
import { log } from '@/utils/functions'

export class WalletModule extends ModuleBase {
  public bankInfo_: any = null

  public bankNoAcc = '' //绑定银行卡卡号（手机号）
  public bankName = '' //绑定银行卡姓名（前端储存）
  public beneficiaryName = '' //暂存的银行卡姓名

  init(): void {
    this.bankInfo_ = this.loadBankInfo_()
    this.loadBankInfoName_()
  }

  onClear(): void {
    this.bankNoAcc = ''
    this.bankName = ''
    this.beneficiaryName = ''
  }

  onLoad(): void {}

  onDestroy(): void {}

  //sendClient2ProxyReqWithDraw(msg) {
  //    hall.network.send(MsgIDs.Client2ProxyReqWithDraw, msg)
  //}

  inits2c(): void {
    ;(hall.s2c as any)['onClient2ProxyAckWithDraw'] = function (msg: any) {
      const res = msg.Res
      if (res == 0) {
        // local userId = msgTbl.UserID
        // local amount = msgTbl.Amount         --金额
        // local gold  = msgTbl.Gold            --目前的全部金币
        // local order = msgTbl.Order           --订单号
        // local orderStat = msgTbl.OrderStat   --订单状态
        const gold = hall.userModule.gold
        const withdraw = hall.userModule.withdraw

        hall.userModule.setProperty(
          String(gold - Number(msg.Amount)),
          null as any,
          String(withdraw - Number(msg.Amount)),
          null as any,
          null as any,
        )

        hall.userModule.sendClient2ProxyReqGetBalance()

        base.uiHudSystem.show('SystemTips', hall.Language.WithdrawSuccessDialog)
        //base.toast( hall.Language.WithdrawSuccessDialog );
        hall.eventDispatcher.emit(hall.EventDefine.PlayerMoneyChange)
      } else if (res == 503) {
        // 当日成功提现次数已经达到上限
        base.toast(hall.Language.withdraw_tips_content)
      } else {
        base.toast(serverErrorMsg(res))
      }
    }
  }

  onPreloadData(): void {
    log('WalletModule onPreloadData')
    hall.userModule.sendClient2ProxyReqGetBalance()
  }

  getBankInfo() {
    return this.bankInfo_
  }

  addBankInfo(bankInfo: any) {
    this.bankInfo_ = bankInfo

    this.saveBankInfo_(this.bankInfo_)
  }

  clearBankInfos() {
    this.bankInfo_ = null
    localStorage.removeItem(hall.DataKeyDefine.BankInfos)
    hall.eventDispatcher.emit(hall.EventDefine.BankInfosChange)
  }

  loadBankInfo_() {
    const infoStr = localStorage.getItem(hall.DataKeyDefine.BankInfos)
    if (infoStr == null || infoStr == '') {
      return null
    }

    const info = JSON.parse(infoStr)
    return info
  }

  saveBankInfo_(bankInfo: any) {
    const infoStr = JSON.stringify(bankInfo)
    localStorage.setItem(hall.DataKeyDefine.BankInfos, infoStr)
  }

  //获取银行卡姓名
  loadBankInfoName_() {
    const infoNameStr = localStorage.getItem(hall.DataKeyDefine.BankAccNameInfo)
    if (infoNameStr == null || infoNameStr == '') {
      this.bankName = ''
      return
    }

    const info = JSON.parse(infoNameStr)
    this.bankName = info
  }

  //删除银行卡姓名
  clearBankInfoName_() {
    this.bankName = ''
    localStorage.removeItem(hall.DataKeyDefine.BankAccNameInfo)
  }

  addBankInfoName_(bankName: string) {
    this.bankName = bankName

    this.saveBankInfoName_()
  }

  //获取银行卡手机号 和姓名
  getBankAccInfo() {
    this.loadBankInfoName_()
    this.getUserBank()
  }

  saveBankInfoName_() {
    const infoStr = JSON.stringify(this.bankName)
    localStorage.setItem(hall.DataKeyDefine.BankAccNameInfo, infoStr)
  }

  showFillBankInfoDialog() {
    const name = this.getFillEWalletDialogName()
    base.uiHudSystem.show(name)
  }

  getFillEWalletDialogName() {
    //判断语言版本
    //let country = hall.configModule.country
    //if(country == Country.India)
    //{
    //     return "IndiaWalletPanel"
    //}
    //else
    //{
    return 'FillWalletPanel'
    //}
    //if (i18nMgr.getLanguage() == "my") {
    //return "FillWalletMyPanel"
    //}
    //else //if (i18nMgr.getLanguage() == "en")
    //{
    //    return "FillWalletPanel"
    //}
  }

  //用户绑定银行卡
  bindBank(bankNo: string): void {
    const data = {
      BankNo: bankNo,
      uid: hall.userModule.userId,
    }

    base.httpUtil
      .postJson(WebDefine.BindUserBankNo, data)
      .then((respJson) => {
        if (respJson.code == 200) {
          hall.walletModule.bankNoAcc = bankNo
          hall.walletModule.addBankInfoName_(hall.walletModule.beneficiaryName)
          hall.eventDispatcher.emit(hall.EventDefine.BankAccChangeSuccess)
          hall.eventDispatcher.emit(hall.EventDefine.BankInfosChange)
        } else {
          // DbSelectFail = 505 // Data query failed 数据查询失败
          // BankNoAlreadyExist = 553 // BankNo already exist 银行卡号已存在
          // UserNull = 516 // User does not exist 玩家不存在
          // DbUpdateFail = 546 // Db update fail 数据修改失败
          // BankNoEmpty = 552 // BankNo cannot be empty 银行卡号不能为空
          // UidZero = 503 // Uid cannot be zero 玩家id不能为零
          base.toast(respJson.msg)
        }
      })
      .catch(() => {})
  }

  //用户绑定银行卡(巴基斯坦用)
  bindBankPAK(bankNo: string): void {
    hall.walletModule.bankNoAcc = bankNo
    hall.walletModule.addBankInfoName_(hall.walletModule.beneficiaryName)
    hall.eventDispatcher.emit(hall.EventDefine.BankAccChangeSuccess)
    hall.eventDispatcher.emit(hall.EventDefine.BankInfosChange)
  }

  //用户清空银行卡
  clearBank(): void {
    const data = {
      uid: hall.userModule.userId,
    }

    base.httpUtil
      .postJson(WebDefine.ClearUserBankNo, data)
      .then((respJson) => {
        if (respJson.code == 200) {
          hall.walletModule.bankNoAcc = ''
          hall.walletModule.clearBankInfoName_()
          hall.eventDispatcher.emit(hall.EventDefine.BankInfosChange)
          base.toast(hall.Language.Deleted)
        } else {
          // DbSelectFail = 505 // Data query failed 数据查询失败
          // BankNoAlreadyExist = 553 // BankNo already exist 银行卡号已存在
          // UserNull = 516 // User does not exist 玩家不存在
          // DbUpdateFail = 546 // Db update fail 数据修改失败
          // BankNoEmpty = 552 // BankNo cannot be empty 银行卡号不能为空
          // UidZero = 503 // Uid cannot be zero 玩家id不能为零
          base.toast(respJson.msg)
        }
      })
      .catch(() => {})
  }

  //获取用户信息
  getUserBank(): void {
    const data = {
      uid: hall.userModule.userId,
    }

    base.httpUtil
      .postJson(WebDefine.GetUserInfoNo, data)
      .then((respJson) => {
        if (respJson.code == 200) {
          //  "uid": "1",
          //       "nickname": "12154545",
          //       "regaccount": "吴系挂",
          //       "BankCardNo": 2 ,
          //       "Channel": "1436864169",
          //       "Mobile": "0",
          hall.walletModule.bankNoAcc = respJson.data.BankCardNo
          hall.eventDispatcher.emit(hall.EventDefine.BankAccChange)
        } else {
          // DbSelectFail = 505 // Data query failed 数据查询失败
          // BankNoAlreadyExist = 553 // BankNo already exist 银行卡号已存在
          // UserNull = 516 // User does not exist 玩家不存在
          // DbUpdateFail = 546 // Db update fail 数据修改失败
          // BankNoEmpty = 552 // BankNo cannot be empty 银行卡号不能为空
          // UidZero = 503 // Uid cannot be zero 玩家id不能为零
          base.toast(respJson.msg)
        }
      })
      .catch(() => {})
  }

  sendClient2ProxyReqWithDraw(msg: any): void {
    base.httpUtil
      .postJson(WebDefine.userWithdraw, msg)
      .then((respJson) => {
        const res = respJson.code
        if (res == 200) {
          // local userId = msgTbl.UserID
          // local amount = msgTbl.Amount         --金额
          // local gold  = msgTbl.Gold            --目前的全部金币
          // local order = msgTbl.Order           --订单号
          // local orderStat = msgTbl.OrderStat   --订单状态
          const gold = hall.userModule.gold
          const withdraw = hall.userModule.withdraw

          hall.userModule.setProperty(
            String(gold - Number(msg.Amount)),
            null as any,
            String(withdraw - Number(msg.Amount)),
            null as any,
            null as any,
          )

          hall.userModule.sendClient2ProxyReqGetBalance()

          base.uiHudSystem.show('SystemTips', hall.Language.WithdrawSuccessDialog)
          //base.toast( hall.Language.WithdrawSuccessDialog );
          hall.eventDispatcher.emit(hall.EventDefine.PlayerMoneyChange)
        } else if (res == 503) {
          // 当日成功提现次数已经达到上限
          base.toast(hall.Language.withdraw_tips_content)
        } else {
          base.toast(respJson.msg)
        }
      })
      .catch(() => {})
  }

  //获取提现请求消息体
  getWithDrawMessageBody() {
    const message = {
      UserID: 0,
      Mail: '',
      Amount: '',
      Biz: '',
      BankCardType: '',
      BankCode: 'paytm.wallet.payout',
      BankCardNo: '',
      BankCardName: '',
      CertType: '',
      CertId: '',
      Mobile: '',
      CreditValid: '',
      CreditCvv: '',
      BankProvince: '',
      BankCity: '',
      BankLineCode: '',
      BankName: '',
      Remark: '',
      FirstName: '',
      LastName: '',
      CardYear: '',
      CardMonth: '',
      Type: 0, // 0表示默认支付 1表示dockpay支付
      Currency: 'IDR', // 国家 默认是"IDR"
      PmId: 'paytm.wallet.payout', // "payout.bank.in" 印度银行卡代付 "doku.wallet.payout" Doku钱包代付 "paytm.wallet.payout" Paytm钱包代付
      BankType: 0, // 0: 旧的银行信息；1：电子钱包；2：新的银行信息
      EwalletType: '', // 电子钱包名称，"BKASH" 或 "NAGAD"
      ChannelID: 1, // 渠道ID
      CardId: 0,
    }
    return message
  }
}
